import React from 'react';
import PageHeader from 'Components/PageHeader';
import { useTranslation } from 'react-i18next';
import { RoleService } from 'Services';
import NewSimulationButton from '../NewSimulationButton';
import styles from './SimulationsHeader.css';

const SimulationsHeader = () => {
    const { t } = useTranslation();

    return (
        <PageHeader>
            <PageHeader.Left data-testid='mainPageHeader' className={styles.headerText}>
                {t('Simulations')}
            </PageHeader.Left>
            <PageHeader.Right>{RoleService.hasEditRuleOrBulkUploadAccess && <NewSimulationButton />}</PageHeader.Right>
        </PageHeader>
    );
};

export default React.memo(SimulationsHeader);
